import React from "react";

import { AskDownloadStep } from "@keepeek/refront-components";

import { KIcon } from "../../components/common/KIcon";
import { useDownloadManager } from "../../providers/downloadManager/hooks";
import useAskDownloads from "../../providers/downloadManager/hooks/askDownloads";

const AskDownload = function () {
  const { open, closeDownloadManager, elementsToDownloadCount, goToStepOne } = useDownloadManager();
  const { askDownloadElementIds, backFromAskDownload, fields } = useAskDownloads(
    open,
    closeDownloadManager,
  );

  return (
    <AskDownloadStep
      elementsToDownloadCount={elementsToDownloadCount}
      goToStepOne={goToStepOne}
      askDownloadElementIds={askDownloadElementIds}
      backFromAskDownload={backFromAskDownload}
      KIcon={KIcon}
      fields={fields}
    />
  );
};

export default AskDownload;
